export class BeanActionPlanFiles { 
    constructor(
        public plaaIdCdPlanoacaoanexo: string,
        public placIdCdPlanoacao: string,
        public plaaDsArquivo: string,
        public plaaDsNomearquivo: string,
        public plaaDhRegistro: string
        
    ){} 
}